import { Router, NavModel, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when, anyNumber, anything } from 'ts-mockito';
import { State } from '../../services/global-state';
import { NavBar } from './nav-bar';
import { PayrazrService } from '../../services/payrazr';
import { MessagesService } from '../../services/messages.service';
import { Customer } from '../../models/customer';

describe('NewPortalWeb', () => {
	describe('components', () => {
		describe('nav-bar', () => {
			let component: NavBar;
			const mockCustomer: Customer = mock(Customer);
			const mockRouter: Router = mock(Router);
			const mockState: State = mock(State);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockMessagesService: MessagesService = mock(MessagesService);
			const mockI18N: I18N = mock(I18N);

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			// Initialize Component
			beforeEach(() => {
				when(mockCustomer.name).thenReturn('Jon Doe');
				when(mockState.customer).thenReturn(instance(mockCustomer));
				component = new NavBar(
					instance(mockRouter),
					instance(mockState),
					instance(mockMessagesService),
					instance(mockPayrazrService),
					instance(mockI18N)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
			});

			describe('loadNavItems()', () => {
				const route = new NavModel(mockRouter, 'testUrl');
				it('should skip i18N when no fallbacktext is defined', () => {
					route.title = 'testTitle';
					route.settings.fallbackText = null;
					when(mockRouter.navigation).thenReturn([route]);
					component.loadNavItems();
					expect(route.title).toEqual('testTitle');
					expect(route.settings.fallbackText).toEqual(null);
				});
				it('should use i18N when fallbacktext is defined', () => {
					route.title = 'testTitle';
					route.settings.fallbackText = 'fallbackTitle';
					when(mockRouter.navigation).thenReturn([route]);
					component.loadNavItems();
					expect(route.title).toEqual('localized');
				});
			});

			describe('logout()', () => {
				when(mockState.business).thenReturn({
					sessionId: '1234567890'
				});
				it('should call the proper service on logout', async () => {
					const response = {
						isSuccessful: true
					};
					when(mockPayrazrService.logout(anything())).thenReturn(Promise.resolve(response));
					await component.logout();
					verify(mockState.logout()).called();
					verify(mockRouter.navigateToRoute('login')).called();

				});

			});

			describe('toggleMenu()', () => {
				it('should flip the toggle flag and set aria-expanded', () => {
					component.toggle = false;
					let anchor = document.createElement('a');
					anchor.setAttribute('href', '#');
					let option = document.createElement('li');
					option.append(anchor);
					let sideMenuListMobile = document.createElement('ul');
					sideMenuListMobile.setAttribute('id', 'sideMenuListMobile');
					sideMenuListMobile.append(option);
					component.sideMenuListMobile = sideMenuListMobile;
					let element = document.createElement('div');
					spyOn(document, 'getElementById').and.returnValue(element);
					component.toggleMenu();
					expect(component.toggle).toEqual(true);
					expect(element.getAttribute('aria-expanded') === 'true').toEqual(true);
				});

			});

			describe('navigateToRoute()', () => {
				it('should navigate to the specified route', () => {
					const route = 'testRoute';
					component.navigateToRoute(route);
					verify(mockRouter.navigate(route)).called();
				});

			});
		});
	});
});
